
import React from "react";
import ProblemStatement from '../Components/Dashboard/Product-Portfolio/ProblemStatement';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthProblemStatement = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <ProblemStatement /> : <SessionTimeoutRedirect />
}
export default AuthProblemStatement;


